// tslint:disable:no-any
// tslint:disable:no-string-literal

import * as React from 'react';
import Message from '../components/Message';
import { isUniqueMessage } from '../components/Messages';
import { DisplayDateTime } from '../components/Display';
import { DiveService } from '../services/DiveService';
import { SettingsService } from '../services/SettingsService';

export interface IDiveCommentsProps {
    dive: any;
}

export interface IDiveCommentsState {
    dive: any;
    diveComment: string;
    messages: Array<any>;
    validFields: Array<any>;
}

export default class DiveComments extends React.Component<
    IDiveCommentsProps,
    IDiveCommentsState
    > {
    constructor(props: IDiveCommentsProps) {
        super(props);
        this.state = {
            dive: props.dive,
            diveComment: '',
            messages: [],
            validFields: []
        };
    }

    componentWillReceiveProps(nextProps: IDiveCommentsProps) {
        this.setState({
            dive: nextProps.dive
        });
    }

    addMessage(text: string, type: string = 'info', autoClose: boolean = true) {
        if (isUniqueMessage(text, this.state.messages)) {
            let newMessages = [...this.state.messages];
            newMessages.push({
                text: text,
                type: type,
                autoClose: autoClose
            });

            this.setState({
                messages: newMessages
            });
        }
    }

    onMessageClose() {
        this.setState({
            messages: []
        });
    }

    checkValidFields() {
        let newValidFields = [...this.state.validFields];
        // tslint:disable-next-line:no-string-literal
        newValidFields['diveComment'] =
            this.state.diveComment === '' ? 'Please enter your comment' : true;

        this.setState({
            validFields: newValidFields
        });
    }

    onChangeDiveComment(event: any) {
        this.setState(
            {
                diveComment: event.target.value
            },
            () => {
                if (this.state.diveComment !== '') {
                    this.checkValidFields();
                }
            }
        );
    }

    async onSaveNewComment() {
        this.checkValidFields();

        if (this.state.diveComment !== '') {
            // tslint:disable-next-line:max-line-length
            const result = await DiveService.getInstance().newDiveComment(this.state.dive.diveAndMixes.dive.id, this.state.diveComment);

            if (result == undefined) {
                this.addMessage('', 'error');
            } else {
                const newDive = this.state.dive;
                // aktualizace seznamu komentaru
                newDive.comments.push({
                    dateCreated: new Date(),
                    text: this.state.diveComment,
                    user: SettingsService.getInstance().getNameOrEmail()
                });

                // vycisteni formulare
                this.setState({
                    dive: newDive,
                    diveComment: '',
                    validFields: []
                });

                // hotovo
                this.addMessage('Comment saved', 'success');

            }
        }
    }

    render() {
        return (
            <section className="dive__comments">
                <h3>Comments :</h3>

                <div>
                    {this.state.dive.comments.length === 0 && (
                        <span className="no-comments">No comments yet</span>
                    )}

                    {this.state.dive.comments.map(
                        (comment: any, index: number) => {
                            return (
                                <div
                                    key={index}
                                    className="dive__comments__item cf"
                                >
                                    <div className="dive__comments__item__img hidden">
                                        <img
                                            src="https://placeholdit.co//i/555x150"
                                            alt=""
                                        />
                                    </div>

                                    <div className="dive__comments__item__text">
                                        <div>
                                            <span>{comment.user}</span>
                                            <span>
                                                <DisplayDateTime
                                                    data={comment.dateCreated}
                                                />
                                            </span>
                                        </div>
                                        <p>{comment.text}</p>
                                    </div>
                                </div>
                            );
                        }
                    )}

                    {this.state.messages.length > 0 && (
                        <div className="messages">
                            {this.state.messages.map((message, index) => {
                                return (
                                    <Message
                                        key={index}
                                        type={message.type}
                                        text={message.text}
                                        autoClose={message.autoClose}
                                        onClose={() => this.onMessageClose()}
                                    />
                                );
                            })}
                        </div>
                    )}

                    <div className="form dive__comments__form">
                        <div className="dive__comments__form__label">
                            New comment :
                        </div>

                        <div className="dive__comments__form__textarea">
                            <div
                                className={
                                    this.state.validFields['diveComment'] !==
                                        undefined &&
                                        this.state.validFields['diveComment'] !==
                                        true
                                        ? 'error'
                                        : ''
                                }
                            >
                                <textarea
                                    name="diveComment"
                                    value={this.state.diveComment}
                                    onChange={e => this.onChangeDiveComment(e)}
                                />
                                {this.state.validFields['diveComment'] !==
                                    undefined &&
                                    this.state.validFields['diveComment'] !==
                                    true && (
                                        <div className="alert">
                                            {
                                                this.state.validFields[
                                                'diveComment'
                                                ]
                                            }
                                        </div>
                                    )}
                            </div>
                            <button
                                className="btn btn--smallpill btn--colorRed btn--borderRed"
                                onClick={() => this.onSaveNewComment()}
                            >
                                Add comment
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveComments.tsx